module.exports = __webpack_public_path__ + "img/sumary_grid-v2.1209a387.svg";